<template>
  <NavBar
    :active="active"
    :create_router_to="$acl.check('IT') ? {name: 'create-releases'} : null"
    :create_text="$t('Common.Add')"
    :items="features"
    :loading="loading"
    :mode.sync="small"
    :types="types"
    unload
    :witout_creating="$acl.not.check('isAdmin')"
    @filterItems="choeseType">
    <template #list_item="{ item }">
      <div class="flex">
        <sIcon
          class="mr-1 my-auto"
          :color="item.type ? getColor(item.type).background : 'grey'"
          size="8"
          type="dot"/>
        {{ item.text }}
      </div>
      <div class="type-count">
        {{ featureDetail[item.type || 'all'] ? featureDetail[item.type || 'all'].amount : 0 }}
      </div>
    </template>
    <template #additional>
      <sCheckbox
        v-if="!small"
        v-model="notify"
        :value="notify"
        @change="changeReleaseNotificationOption">
        {{ $t('Releases.NotifyOfUpdates') }}
      </sCheckbox>
    </template>
  </NavBar>
</template>
<script>
import NavBar from 'components/common/blocks/NavBar.vue'
import { mapGetters } from 'vuex'
import { modalMixin, releaseMixin } from 'mixins'

export default {
  name: 'clientReleasesNavBar',
  mixins: [ releaseMixin , modalMixin],
  data() {
    return {
      active: 0,
      active_fiter: false,
      notify: true,
      small: false,
      // types: []
    }
  },
  props: {
    releases: Array,
    features: Array,
    loading: Boolean,
    custom_title: String,
  },
  created() {
    this.notify = !this.releaseSettings?.dontNotify
  },
  computed: {
    ...mapGetters({
      releaseSettings: 'getReleasesSettings',
    }),
  },
  methods: {
    choeseType(filter) {
      const index = this.types.findIndex(i => i.type === filter.type)
      if (index !== -1) {
        this.active = index
        this.$emit('update:custom_title', filter.text)
        this.$emit('choeseType', filter)
      }
    },
    changeReleaseNotificationOption() {
      this.$store.dispatch( 'changeReleaseNotificationOption', !this.notify )
    }
  },
  components: {
    NavBar
  }
}
</script>
<style lang="scss" scoped>
.menu-open-icon {
  width: 20px;
}
</style>
